import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BED_NUMBER_PATH = "/bed-number/v1";

export const getBedNumberApi = async (params) =>
  await getRequest(BED_NUMBER_PATH, params);

export const getBedNumberByIdApi = async (id) =>
  await getRequest(`${BED_NUMBER_PATH}/${id}`);

export const addBedNumberApi = async (body) =>
  await postRequest(BED_NUMBER_PATH, body);

export const updateBedNumberApi = async (body) =>
  await putRequest(`${BED_NUMBER_PATH}/${body?._id}`, body);

export const deleteBedNumberByIdApi = async (id) =>
  await deleteRequest(`${BED_NUMBER_PATH}/${id}`);

// nursing lists

export const getNursingBedNumberApi = async (params) =>
  await getRequest(`${BED_NUMBER_PATH}/listNursingBeds`, params);
